import { Moment } from "moment-timezone"
import moment from "moment-timezone"

export const browserTimeZone = moment.tz.guess()

export enum CONSTANTS {
    isoFormatString = "%Y-%m-%d %H:%M:%SZ",
    xFormatString = "%m/%-d/%y"
}

export const formatDateToMonth = (date: Date) => {
    return `${date.toLocaleString("en-us", { month: "short" })}`
}

// This returns a timezone aware moment object. If there is a trailing "Z"
// the date string is assumed to be UTC, else it defaults to "America/Los_Angeles"
export const dateStringToMomentDate = (dateString: string): Moment => {
    if (dateString[dateString.length - 1].toLowerCase() === "z") {
        // This is UTC date
        return moment.utc(dateString).startOf("day")
    } else {
        return moment.tz(dateString, "America/Los_Angeles").startOf("day")
    }
}

export const getDateString = (date: Moment): string => {
    return date.format("MM/DD/YY")
}

export const getDateTimeString = (date: Moment): string => {
    return date.format("YYYY-MM-DD HH:mm:ss[Z]")
}

export const utcStrToLocalString = (dateString: string) => {
    const momentDate = dateStringToMomentDate(dateString)
    // This is to keep the date in the proper date.
    // The browser will always try to present the date the local timezone
    // i.e. it does not respect the 'Z' so we force it into PST.
    momentDate.add(8, "hours")
    return getDateTimeString(momentDate)
}

export const momentToDate = (momentDate: Moment): Date => {
    const dateStr = momentDate.format()
    const out = new Date(dateStr)
    return out
}

export const dateToMoment = (date: Date): Moment => {
    return moment(date).startOf("day")
}

//return a moment for the current time
export const getNow = () => {
    return moment().startOf("day")
}

// Convert date with timezone to UTC using day/month/year
export const localToUtc = (date: Moment, tz?: string): Moment => {
    tz = tz ? tz : "GMT"
    const day = date.date()
    const mon = date.month() + 1
    const year = date.year()

    return moment.tz(`${year}-${mon}-${day}`, tz).add(1, "d")
}

export type Filter<T, U> = T extends U ? T : never

export const formatNumber = (value: number) => {
    if (value < 1) {
        return `${Number(value).toFixed(2)}`
    } else if (value >= 1 && value < 10) {
        return `${Number(value).toFixed(1)}`
    } else if (value >= 10 && value < 10000) {
        return `${Number(value).toFixed(0)}`
    } else if (value > 10000) {
        const num = value.toExponential(1)
        return `${num}`
    }
    return `${value}`
}

export const getEnvironment = (): string => {
    const host = window.location.host
    let env = "unknown"
    if (host.includes("localhost")) {
        env = "local"
    } else if (host.includes("staging")) {
        env = "staging"
    } else if (host.includes("detroitlake.thepredictionlab")) {
        env = "production"
    }
    return env
}

export const showCurrentDate = (startDate: Moment, midDate: Moment, endDate?: Moment): boolean => {
    let out = true
    if (midDate.diff(startDate, "d") < 0 || midDate.diff(endDate, "d") > 0) {
        out = false
    }
    return out
}

export const getUtcOffset = (date: Moment): number => {
    return date.utcOffset()
}

export const addOffset = (date: string, offsetMinutes: number): string => {
    const newDate = localToUtc(dateStringToMomentDate(date), browserTimeZone)
    return getDateTimeString(newDate)
}
